import MarketComponentEditDialogDesktopView from './desktop/MarketComponentEditDialog.desktop.view';
import type MarketComponentEditDialogProperties from './MarketComponentEditDialog.properties.ts';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';

export default function MarketComponentEditDialogView(props: MarketComponentEditDialogProperties) {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <MarketComponentEditDialogDesktopView {...props} />}</>;
}
